import { Box, Typography, styled } from '@mui/material'

const Container = styled(Box)(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.veryLightGray,
  boxSizing: 'border-box',
  padding: '8px 12px',
}))

const TitleTypography = styled(Typography)`
  flex-grow: 1;
`

export function DateSeparator({ date }: { date: string }) {
  return (
    <Container>
      <TitleTypography color="gray" variant="body2">
        {date}
      </TitleTypography>
    </Container>
  )
}
